/* eslint-disable @typescript-eslint/no-explicit-any */
import { createTheme, Theme } from "@mui/material"
import shadows from "./boxShadows"
import breakpoints from "./breakpoints"
import customizedButton from "./button"
import customizedCheckbox from "./checkbox"
import customizedChip from "./chip"
import customezedDialog from "./dialog"
import customizedToggleGroup from "./toggleGroup"
import customizedToggle from "./toggle"
import customizedSwitch from "./switch"
import inputBase from "./input"
import palette from "./palette"
import customizedSelect from "./select"
import typography from "./typography"

/**
 * - Create theme derived from default MuiTheme
 * - Set breakpoints based on figma design
 * - Customize MUI components to match Vacasa owner onboarding design: like card, button, textfield etc
 * - Owner onboarding still defining all its box-shadows, so will add its shadows to a new prop named appShadows instead of overriding MUI default 25 shadows
 */
const theme: Theme = createTheme({
    breakpoints: {
        values: breakpoints.values,
    },
    typography,
    appShadows: shadows, // shadows used in figma
    palette,
    components: {
        MuiInputBase: inputBase,
        MuiButton: customizedButton as any,
        MuiChip: customizedChip as any,
        MuiDialog: customezedDialog as any,
        MuiSelect: customizedSelect as any,
        MuiCheckbox: customizedCheckbox as any,
        MuiToggleButtonGroup: customizedToggleGroup as any,
        MuiToggleButton: customizedToggle as any,
        MuiSwitch: customizedSwitch as any
    },
})

export default theme
